import React from "react";

type FooterProps = {
  logoSrc?: string;
  logoAlt?: string;
  tagline?: string;
  cityLabel?: string; // e.g., "Bogotá - Colombia"
  mapEmbedSrc?: string; // iframe embed URL de Google Maps
  social?: {
    facebook?: string;
    instagram?: string;
    tiktok?: string;
  };
};

const Footer: React.FC<FooterProps> = ({
  logoSrc = "/images/logo-horizontal.png",
  logoAlt = "Magníficos ya!",
  tagline = "Sé parte del negocio que está revolucionando la industria en Latinoamérica",
  cityLabel = "Bogotá - Colombia",
  mapEmbedSrc = "https://www.google.com/maps?q=Bogotá%2C%20Colombia&output=embed",
  social = {
    facebook: "#",
    instagram: "#",
    tiktok: "#",
  },
}) => {
  return (
    <footer className="w-full bg-black text-white">
      <div className="mx-auto max-w-7xl px-4 py-10 md:py-12">
        <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-3">
          {/* Columna izquierda: Logo */}
          <div className="flex md:justify-start justify-center">
            <img
              src={logoSrc}
              alt={logoAlt}
              className="h-16 md:h-20 w-auto select-none"
              loading="lazy"
            />
          </div>

          {/* Columna centro: Tagline */}
          <div className="text-center">
            <p className="mx-auto max-w-xs leading-relaxed text-sm md:text-base font-light italic">
              {tagline}
            </p>
          </div>

          {/* Columna derecha: Mapa + redes + leyenda */}
          <div className="flex flex-col items-center md:items-end gap-3">
            <span className="text-[10px] opacity-80">{cityLabel}</span>

            <div className="w-52 h-28 overflow-hidden rounded-md">
              <iframe
                title="Ubicación"
                src={mapEmbedSrc}
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Íconos de redes */}
            <div className="flex items-center gap-4 mt-1">
              {/* Facebook */}
              <a
                href={social.facebook}
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
                className="transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-white/40 rounded"
              >
                <img
                  src="/images/icons/facebook.svg"
                  alt="Facebook"
                  className="w-7 h-7"
                  loading="lazy"
                />
              </a>

              {/* Instagram */}
              <a
                href={social.instagram}
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
                className="transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-white/40 rounded"
              >
                <img
                  src="/images/icons/Instagram.svg"
                  alt="Instagram"
                  className="w-7 h-7"
                  loading="lazy"
                />
              </a>

              {/* TikTok */}
              <a
                href={social.tiktok}
                aria-label="TikTok"
                target="_blank"
                rel="noreferrer"
                className="transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-white/40 rounded"
              >
                <img
                  src="/images/icons/tiktok.svg"
                  alt="TikTok"
                  className="w-7 h-7"
                  loading="lazy"
                />
              </a>
            </div>

            <p className="text-xs opacity-90 text-center md:text-right">
              Un equipo experto a tu servicio
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;